import React from "react";
import {
  ComponentProjectDetailPageContent,
  ComponentProjectDetailPageStateProvider,
} from ".";
import { DesignInfoInputDialogStateProvider } from "../dialog/design-info-input-dialog";
import { ProjectStakeholderListStateProvider } from "../dialog/project-stakeholder-list/ProjectStakeholderListStateProvider";
import { InputStakeholderDialogStateProvider } from "../dialog/input-stakeholder-dialog/InputStakeholderDialogStateProvider";
import { UserSearchDialogStateProvider } from "../dialog/user-search-dialog/UserSearchDialogStateProvider";
import { MemoEditDialogStateProvider } from "../dialog/memo-edit-dialog";

export const ComponentProjectDetailPage = () => {
  return (
    <>
      <MemoEditDialogStateProvider>
        <ProjectStakeholderListStateProvider>
          <InputStakeholderDialogStateProvider>
            <UserSearchDialogStateProvider>
              <DesignInfoInputDialogStateProvider>
                <ComponentProjectDetailPageStateProvider>
                  <ComponentProjectDetailPageContent></ComponentProjectDetailPageContent>
                </ComponentProjectDetailPageStateProvider>
              </DesignInfoInputDialogStateProvider>
            </UserSearchDialogStateProvider>
          </InputStakeholderDialogStateProvider>
        </ProjectStakeholderListStateProvider>
      </MemoEditDialogStateProvider>
    </>
  );
};
